// import React, { useState } from "react";

// const Enquiry = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     pickup: "",
//     drop: "",
//     tripType: "Outstation",
//     cab: "Swift Dzire (4+1 Seater)",
//     date: "",
//     message: "",
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const whatsappMessage = `
// *🚖 New Cab Enquiry – Srs Cab Service*

// 👤 Name: ${formData.name}
// 📞 Phone: ${formData.phone}
// ✉️ Email: ${formData.email}

// 🚕 Trip Type: ${formData.tripType}
// 📍 Pickup: ${formData.pickup}
// 📍 Drop: ${formData.drop}
// 🚘 Cab Selected: ${formData.cab}
// 🗓 Journey Date: ${formData.date}

// 💬 Message:
// ${formData.message}
//     `;

//     const whatsappUrl = `https://wa.me/919011955415?text=${encodeURIComponent(
//       whatsappMessage
//     )}`;

//     window.open(whatsappUrl, "_blank");
//   };

//   return (
//     <>
//       {/* Breadcrumb */}

//  <div className="breadcrumb-bar">
//       <div className="container">
//         <div className="row align-items-center text-center">
//           <div className="col-md-12 col-12">
//             <h2 className="breadcrumb-title">Enquiry</h2>
//           </div>
//         </div>
//       </div>
//     </div>








//       {/* Enquiry Form */}
//       <section className="enquiry-section">
//         <div className="enquiry-wrapper">
//           <div className="enquiry-title">
//             <h2>Send Us A Message</h2>
//             <p>Fill out the form and we’ll reply via WhatsApp</p>
//           </div>

//           <form onSubmit={handleSubmit}>
//             {/* Name & Email */}
//             <div className="form-row">
//               <input
//                 type="text"
//                 name="name"
//                 placeholder="Your Full Name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 required
//               />
//               <input
//                 type="email"
//                 name="email"
//                 placeholder="Your Email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//               />
//             </div>

//             {/* Phone & Trip Type */}
//             <div className="form-row">
//               <input
//                 type="text"
//                 name="phone"
//                 placeholder="Your Phone Number"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 required
//               />

//               <select
//                 name="tripType"
//                 value={formData.tripType}
//                 onChange={handleChange}
//               >
//                 <option>Local</option>
//                 <option>Outstation</option>
//                 <option>One Way</option>
//                 <option>Round Trip</option>
//                 <option>Airport Transfer</option>
//               </select>
//             </div>

//             {/* Pickup & Drop */}
//             <div className="form-row">
//               <input
//                 type="text"
//                 name="pickup"
//                 placeholder="Pickup Location"
//                 value={formData.pickup}
//                 onChange={handleChange}
//                 required
//               />
//               <input
//                 type="text"
//                 name="drop"
//                 placeholder="Drop Location"
//                 value={formData.drop}
//                 onChange={handleChange}
//                 required
//               />
//             </div>

//             {/* Cab & Date */}
//             <div className="form-row">
//               <select
//                 name="cab"
//                 value={formData.cab}
//                 onChange={handleChange}
//               >
//                 {/* Sedans */}
//                 <option>Swift Dzire (4+1 Seater)</option>
//                 <option>Honda Amaze (4+1 Seater)</option>
//                 <option>Hyundai Aura (4+1 Seater)</option>
//                 <option>Honda City (4+1 Seater)</option>
//                 <option>Toyota Etios (4+1 Seater)</option>

//                 {/* MPVs */}
//                 <option>Maruti Ertiga (6+1 Seater)</option>
//                 <option>Kia Carens (6+1 Seater)</option>
//                 <option>Toyota Innova (7+1 Seater)</option>
//                 <option>Innova Crysta (7+1 Seater)</option>

//                 {/* Luxury */}
//                 <option>Audi A5 (Luxury Sedan)</option>

//                 {/* Tempo / Bus */}
//                 <option>13 Seater Force Urbania</option>
//                 <option>17 Seater Force Urbania</option>
//                 <option>25 Seater Tempo Traveller</option>
//                 <option>Mini Bus</option>
//                 <option>AC Bus</option>
//                 <option>32 Seater Bus</option>
//               </select>

//             <input
//   type="date"
//   name="date"
//   value={formData.date}
//   onChange={handleChange}
//   min={new Date().toISOString().split("T")[0]}
//   required
// />
//             </div>

//             {/* Message */}
//             <textarea
//               name="message"
//               placeholder="Additional Message (Optional)"
//               value={formData.message}
//               onChange={handleChange}
//               rows="4"
//             ></textarea>

//             <button type="submit" className="send-btn">
//               Send Enquiry on WhatsApp
//             </button>
//           </form>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Enquiry;




import React, { useState } from "react";

const Enquiry = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    pickup: "",
    drop: "",
    tripType: "Outstation",
    cab: "Swift Dzire (4+1 Seater)",
    date: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    const data = {
      access_key: "e557b5cd-f8ea-42d9-869a-6b06b19d44d4",

      subject: "🚖 New Cab Enquiry - Srs Cab Service",

      from_name: "Srs Cab Service Website",

      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      tripType: formData.tripType,
      pickup: formData.pickup,
      drop: formData.drop,
      cab: formData.cab,
      date: formData.date,
      message: formData.message,
    };

    try {
      const response = await fetch(
        "https://api.web3forms.com/submit",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      const result = await response.json();

      if (result.success) {

        // Google Ads Conversion
       if (typeof window.gtag === "function") {
  window.gtag("event", "conversion", {
    send_to: "AW-18116390504/eJibCNaew9AcEOjcyL5D",
    value: 1.0,
    currency: "INR",
  });
}

        alert("✅ Enquiry Sent Successfully!");

        setFormData({
          name: "",
          email: "",
          phone: "",
          pickup: "",
          drop: "",
          tripType: "Outstation",
          cab: "Swift Dzire (4+1 Seater)",
          date: "",
          message: "",
        });

      } else {
        alert(result.message || "Unable to send enquiry.");
      }

    } catch (error) {
      console.error(error);
      alert("❌ Something went wrong. Please try again.");
    }

    setLoading(false);
  };

  return (
   
  <>
    {/* Breadcrumb */}
    <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title">Enquiry</h2>
          </div>
        </div>
      </div>
    </div>

    {/* Enquiry Form */}
    <section className="enquiry-section">
      <div className="enquiry-wrapper">
        <div className="enquiry-title">
          <h2>Send Us A Message</h2>
          <p>Fill out the form and we'll get back to you shortly.</p>
        </div>

        <form onSubmit={handleSubmit}>
          {/* Name & Email */}
          <div className="form-row">
            <input
              type="text"
              name="name"
              placeholder="Your Full Name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          {/* Phone & Trip Type */}
          <div className="form-row">
            <input
              type="text"
              name="phone"
              placeholder="Your Phone Number"
              value={formData.phone}
              onChange={handleChange}
              required
            />

            <select
              name="tripType"
              value={formData.tripType}
              onChange={handleChange}
            >
              <option>Local</option>
              <option>Outstation</option>
              <option>One Way</option>
              <option>Round Trip</option>
              <option>Airport Transfer</option>
            </select>
          </div>

          {/* Pickup & Drop */}
          <div className="form-row">
            <input
              type="text"
              name="pickup"
              placeholder="Pickup Location"
              value={formData.pickup}
              onChange={handleChange}
              required
            />

            <input
              type="text"
              name="drop"
              placeholder="Drop Location"
              value={formData.drop}
              onChange={handleChange}
              required
            />
          </div>

          {/* Cab & Date */}
          <div className="form-row">
            <select
              name="cab"
              value={formData.cab}
              onChange={handleChange}
            >
              <option>Swift Dzire (4+1 Seater)</option>
              <option>Honda Amaze (4+1 Seater)</option>
              <option>Hyundai Aura (4+1 Seater)</option>
              <option>Honda City (4+1 Seater)</option>
              <option>Toyota Etios (4+1 Seater)</option>

              <option>Maruti Ertiga (6+1 Seater)</option>
              <option>Kia Carens (6+1 Seater)</option>
              <option>Toyota Innova (7+1 Seater)</option>
              <option>Innova Crysta (7+1 Seater)</option>

              <option>Audi A5 (Luxury Sedan)</option>

              <option>13 Seater Force Urbania</option>
              <option>17 Seater Force Urbania</option>
              <option>25 Seater Tempo Traveller</option>
              <option>Mini Bus</option>
              <option>AC Bus</option>
              <option>32 Seater Bus</option>
            </select>

            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              min={new Date().toISOString().split("T")[0]}
              required
            />
          </div>

          {/* Message */}
          <textarea
            name="message"
            placeholder="Additional Message (Optional)"
            value={formData.message}
            onChange={handleChange}
            rows="4"
          ></textarea>

          <button
            type="submit"
            className="send-btn"
            disabled={loading}
          >
            {loading ? "Sending..." : "Send Enquiry"}
          </button>
        </form>
      </div>
    </section>
  </>
);

};

export default Enquiry;